import React from 'react';

import { QuestionComponentBaseProps } from '../models/surveys';
import { QuestionHeader } from './QuestionHeader';

interface Props extends QuestionComponentBaseProps {
    content: React.ReactNode;
}

export const DummyQuestion: React.SFC<Props> = ({ question, content, readableIndex }) => (
    <>
        {question && <QuestionHeader index={readableIndex} header={question} />}
        {content}
    </>
);
